import { ref, computed } from 'vue'
import { useIntervalFn, createSharedComposable } from '@vueuse/core'
import { whenEppoIsReady, useEppo } from '@/composables/eppo/index.js'
import { useReady } from '@/composables/ready'
import { useLogger } from '@booksy-com/vue-tools'
import { useCore } from '@/composables/core'

import { FEATURE_FLAGS } from '@/lib/consts.js'

const logger = useLogger('maintenance-mode')

const MAINTENANCE_MODE_TYPE = {
  DISABLED: 'disabled',
  INCIDENT: 'incident',
  SCHEDULED: 'scheduled',
}

const MAINTENANCE_MODE_CHECK_INTERVAL = 30000 // 30s

export const useMaintenanceMode = createSharedComposable(() => {
  const { store } = useCore()
  const isCheckingMaintenanceMode = ref(false)
  const isMaintenanceMode = ref(false)
  const maintananceModeType = ref(MAINTENANCE_MODE_TYPE.DISABLED)

  const startCheckingMaintenanceMode = async () => {
    if (isCheckingMaintenanceMode.value) return

    isCheckingMaintenanceMode.value = true

    return whenEppoIsReady.then(() => {
      useIntervalFn(() => {
        const flagState = useEppo().ff(FEATURE_FLAGS.Maintenance_Mode, null, {
          fingerprint: store.state.app.fingerprint,
        })
        if (isMaintenanceMode.value && flagState === MAINTENANCE_MODE_TYPE.DISABLED) {
          window.location.reload()
          return
        }

        if ([MAINTENANCE_MODE_TYPE.INCIDENT, MAINTENANCE_MODE_TYPE.SCHEDULED].includes(flagState)) {
          logger.info(`set maintenance mode ON - type: ${flagState}`)
          isMaintenanceMode.value = true
          maintananceModeType.value = flagState
          useReady().setReady(false)
        }
      }, MAINTENANCE_MODE_CHECK_INTERVAL, { immediateCallback: true })
    })
  }

  return {
    isMaintenanceMode: computed(() => isMaintenanceMode.value),
    maintenanceModeType: computed(() => maintananceModeType.value),
    startCheckingMaintenanceMode,
    MAINTENANCE_MODE_TYPE,
  }
})
